import type { JobModuleTriggerCardsProps } from "./job-module-trigger-cards.type";

import { Flex } from "antd";

import JobModuleTriggerCard from "@/modules/job-module/job-module-trigger-card";
import "./job-module-trigger-cards.style.less";

const JobModuleTriggerCards = ({
  modules,
  subjectType,
  subjectIds,
  loading,
}: JobModuleTriggerCardsProps) => {
  return (
    <Flex gap="middle" vertical={true} className="job-module-trigger-cards">
      {modules.map((module) => {
        return (
          <JobModuleTriggerCard
            key={module.id}
            module={module}
            subjectType={subjectType}
            subjectIds={subjectIds}
            loading={loading}
          />
        );
      })}
    </Flex>
  );
};

export default JobModuleTriggerCards;
